module.exports = __webpack_public_path__ + "static/media/covid_india_map.a6b4cd04.png";